import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class ProductResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/products';

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}